import './polyfills';
import './localization';

import 'font-awesome/css/font-awesome.min.css';
import { LicenseInfo } from '@mui/x-license';
import * as ReactDOM from 'react-dom';

import { Providers } from '~/Providers';

import { App } from './App';
import { unregister } from './serviceWorker';

LicenseInfo.setLicenseKey(
  '19967b21fcc9d99555eb82ae8520ad0fTz0xMTU1ODgsRT0xNzkzMzE4Mzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
);

declare global {
  interface Window {
    RUNTIME_CONFIG: { [key: string]: string };
  }
}

const buildTarget = process.env.REACT_APP_BUILD_TARGET;
if (buildTarget !== 'library') {
  fetch('/v2/env.json')
    .then((res) => res.json())
    .then((config) => {
      window.RUNTIME_CONFIG = config;
      ReactDOM.render(
        <Providers>
          <App />
        </Providers>,
        document.getElementById('root'),
      );
    });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister();

export * from './library';
